import { render, staticRenderFns } from "./NotificationTemplate.vue?vue&type=template&id=45e576c9&"
import script from "./NotificationTemplate.vue?vue&type=script&lang=ts&"
export * from "./NotificationTemplate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports